<template>
  <v-menu class="engagement-filters-multi-menu" offset-y transition="slide-y-transition" :close-on-content-click="false">
    <template v-slot:activator="{ on, value }">
        <v-btn depressed color="transparent" v-on="on" class="filter-list-title" :style="titleStyles">
          {{title}}
          <v-icon v-if="!value" large right>mdi-menu-down</v-icon>
          <v-icon v-else large right>mdi-menu-up</v-icon>
        </v-btn>
    </template>

    <v-list v-for="(group, i) in groups" :key="`list-${i}`" dense width="175px" class="text-right py-0">
      <div class="filter-list-group-title" v-text="group.title"/>

      <v-list-item-group v-model="filters[group.key]">
        <template v-for="(item, j) in group.items">
          <v-list-item :key="`item-${i}-${j}`" :value="item" class="filter-list-item px-3">
            <template v-slot:default="{ active }">
              <v-list-item-content>
                <v-list-item-title v-text="item" class="menu-item"/>
              </v-list-item-content>
              <v-list-item-action>
                <v-checkbox :true-value="item" :input-value="active" color="black"/>
              </v-list-item-action>
            </template>
          </v-list-item>
        </template>

        <v-divider class="mx-5"/>
      </v-list-item-group>

    </v-list>

    <v-list dense width="175px" class="text-right py-0">
      <v-list-item-group>
        <v-list-item @click="clearSelection" class="filter-list-item">
          <v-list-item-content>
            <v-list-item-title v-text="'Clear Selection'"/>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
  export default {
    name: "CvcMultiDropDown",
    data: () => ({
      filters: {}
    }),
    props: {
      title: {
        type: String,
        required: true,
      },
      titleColor: {
        type: String,
        required: true,
      },
      groups: {
        type: Array[Object],
        required: true,
      },
      initial: {
        type: Object,
        required: true,
      },
      onChange: {
        type: Function[Array],
        required: true
      }
    },
    computed: {
      titleStyles() {
        return {
          width: '175px',
          color: this.titleColor
        }
      }
    },
    mounted() {
      this.filters = this.initial
    },
    methods: {
      clearSelection() {
        this.filters = {}
      }
    },
    watch: {
      filters: function (newVal, oldVal) {
        if (oldVal !== null) {
          this.onChange(newVal);
        }
      },
      initial: function (val) {
        this.filters = val
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/mixins";

  .filter-list-title {
    float: right;
    text-transform: none;
    font-weight: bold;
    span {
      display: block;
      text-align: right;
    }
  }
  .filter-list-group-title {
    font-size: 14px;
    font-weight: bold;
    min-height: 40px;
    padding: 16px;
  }
  .menu-item {
    white-space: initial
  }
</style>